"use client";

import { c as _c } from "react/compiler-runtime";
import type { ApiGroupFull } from "@/generated/models/ApiGroupFull";
import { getRandomColorWithSeed, getTimeAgo } from "@/helpers/Helpers";
import { ImageScale, getScaledImageUri } from "@/helpers/image.helpers";
import Image from "next/image";
import Link from "next/link";
interface SelectGroupModalCardProps {
  readonly group: ApiGroupFull;
  readonly isSelected: boolean;
  readonly onSelect: (group: ApiGroupFull) => void;
  readonly onClear?: (() => void) | undefined;
}
export default function SelectGroupModalCard(t0) {
  const $ = _c(55);
  const {
    group,
    isSelected,
    onSelect,
    onClear
  } = t0;
  let t1;
  if ($[0] !== group.created_by.banner1_color || $[1] !== group.created_by.handle) {
    t1 = group.created_by.banner1_color ?? getRandomColorWithSeed(group.created_by.handle ?? "");
    $[0] = group.created_by.banner1_color;
    $[1] = group.created_by.handle;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const avatarAccentStart = t1;
  let t2;
  if ($[3] !== group.created_by.banner2_color || $[4] !== group.created_by.handle) {
    t2 = group.created_by.banner2_color ?? getRandomColorWithSeed(group.created_by.handle ?? "");
    $[3] = group.created_by.banner2_color;
    $[4] = group.created_by.handle;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const avatarAccentEnd = t2;
  const creatorIdentity = group.created_by.handle ?? group.created_by.primary_address;
  let t3;
  if ($[6] !== group.created_at) {
    t3 = getTimeAgo(new Date(group.created_at).getTime());
    $[6] = group.created_at;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const timeAgo = t3;
  let t4;
  if ($[8] !== creatorIdentity) {
    t4 = creatorIdentity.charAt(0).toUpperCase();
    $[8] = creatorIdentity;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const avatarFallbackLabel = t4;
  let t5;
  if ($[10] !== group.name || $[11] !== isSelected || $[12] !== onClear) {
    t5 = isSelected && onClear ? <button type="button" onClick={event => {
      event.stopPropagation();
      onClear();
    }} className="tw-flex tw-h-[18px] tw-w-[18px] tw-flex-shrink-0 tw-appearance-none tw-items-center tw-justify-center tw-rounded-full tw-border-none tw-bg-iron-100 tw-p-0 tw-leading-none tw-shadow-[0_0_10px_rgba(255,255,255,0.2)] tw-transition-all tw-duration-300 hover:tw-scale-110 focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-white/30" aria-label={`Clear selected group ${group.name}`}><svg viewBox="0 0 24 24" fill="none" className="tw-h-3 tw-w-3 tw-flex-shrink-0 tw-text-iron-950" stroke="currentColor" strokeWidth="3.5" aria-hidden="true"><polyline points="20 6 9 17 4 12" /></svg></button> : <div className={`tw-flex tw-h-[18px] tw-w-[18px] tw-flex-shrink-0 tw-items-center tw-justify-center tw-rounded-full tw-border tw-border-solid tw-transition-all tw-duration-300 ${isSelected ? "tw-border-iron-100 tw-bg-iron-100 tw-shadow-[0_0_10px_rgba(255,255,255,0.2)]" : "tw-border-white/10 tw-bg-transparent group-hover:tw-border-white/30"}`} aria-hidden="true">{isSelected && <svg viewBox="0 0 24 24" fill="none" className="tw-h-3 tw-w-3 tw-flex-shrink-0 tw-text-iron-950" stroke="currentColor" strokeWidth="3.5"><polyline points="20 6 9 17 4 12" /></svg>}</div>;
    $[10] = group.name;
    $[11] = isSelected;
    $[12] = onClear;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  const selectionIndicator = t5;
  const t6 = `Select ${group.name}`;
  let t7;
  let t8;
  if ($[14] !== group || $[15] !== onSelect) {
    t7 = () => onSelect(group);
    t8 = event_0 => {
      if (event_0.key === "Enter" || event_0.key === " ") {
        event_0.preventDefault();
        onSelect(group);
      }
    };
    $[14] = group;
    $[15] = onSelect;
    $[16] = t7;
    $[17] = t8;
  } else {
    t7 = $[16];
    t8 = $[17];
  }
  const t9 = `tw-group tw-relative tw-flex tw-cursor-pointer tw-items-center tw-justify-between tw-gap-3 tw-rounded-xl tw-border tw-border-solid tw-p-3 tw-no-underline tw-outline-none tw-transition-all tw-duration-200 ${isSelected ? "tw-border-white/20 tw-bg-iron-900 tw-shadow-[0_0_0_1px_rgba(255,255,255,0.04),0_10px_24px_rgba(0,0,0,0.28),0_0_18px_rgba(255,255,255,0.06)]" : "tw-border-white/[0.06] tw-bg-iron-950 hover:tw-border-white/10 hover:tw-bg-iron-900/60"} focus-visible:tw-border-white/30 focus-visible:tw-bg-iron-900 focus-visible:tw-outline-none focus-visible:tw-ring-1 focus-visible:tw-ring-white/30`;
  const t10 = `linear-gradient(135deg, ${avatarAccentStart} 0%, ${avatarAccentEnd} 100%)`;
  let t11;
  if ($[18] !== t10) {
    t11 = {
      background: t10
    };
    $[18] = t10;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== avatarFallbackLabel || $[21] !== group.created_by.handle || $[22] !== group.created_by.pfp) {
    t12 = group.created_by.pfp ? <Image src={getScaledImageUri(group.created_by.pfp, ImageScale.W_AUTO_H_50)} width={40} height={40} alt={group.created_by.handle ? `${group.created_by.handle} profile picture` : "Group creator profile picture"} className="tw-h-full tw-w-full tw-object-cover" /> : <><svg viewBox="0 0 24 24" fill="none" className="tw-h-4 tw-w-4 tw-text-iron-50 tw-drop-shadow-md" stroke="currentColor" strokeWidth="2.5" aria-hidden="true"><path strokeLinecap="round" strokeLinejoin="round" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" /></svg><span className="tw-sr-only">{avatarFallbackLabel}</span></>;
    $[20] = avatarFallbackLabel;
    $[21] = group.created_by.handle;
    $[22] = group.created_by.pfp;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== t11 || $[25] !== t12) {
    t13 = <div className="tw-relative tw-flex tw-h-9 tw-w-9 tw-flex-shrink-0 tw-items-center tw-justify-center tw-overflow-hidden tw-rounded-full tw-shadow-[inset_0_2px_4px_rgba(255,255,255,0.2),0_2px_8px_rgba(0,0,0,0.4)]" style={t11}>{t12}</div>;
    $[24] = t11;
    $[25] = t12;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  const t14 = `tw-mb-0 tw-block tw-max-w-[12rem] tw-truncate tw-text-sm tw-font-semibold tw-leading-tight tw-transition-colors ${isSelected ? "tw-text-iron-50" : "tw-text-iron-200 group-hover:tw-text-iron-100"}`;
  let t15;
  if ($[27] !== group.name || $[28] !== t14) {
    t15 = <p className={t14} title={group.name}>{group.name}</p>;
    $[27] = group.name;
    $[28] = t14;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  let t16;
  if ($[30] !== creatorIdentity || $[31] !== group.created_by.handle || $[32] !== isSelected) {
    t16 = group.created_by.handle ? <Link href={`/${group.created_by.handle}`} onClick={_temp} className={`tw-inline-block tw-max-w-[8rem] tw-truncate tw-font-medium tw-no-underline tw-transition-colors ${isSelected ? "tw-text-iron-300" : "tw-text-iron-400 group-hover:tw-text-iron-300"}`}>{group.created_by.handle}</Link> : <span className={`tw-inline-block tw-max-w-[8rem] tw-truncate tw-font-medium ${isSelected ? "tw-text-iron-300" : "tw-text-iron-400 group-hover:tw-text-iron-300"}`}>{creatorIdentity}</span>;
    $[30] = creatorIdentity;
    $[31] = group.created_by.handle;
    $[32] = isSelected;
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  let t17;
  if ($[34] !== timeAgo) {
    t17 = timeAgo && <><span className="tw-leading-none tw-text-iron-600">·</span><p className="tw-mb-0 tw-text-iron-500">Created {timeAgo}</p></>;
    $[34] = timeAgo;
    $[35] = t17;
  } else {
    t17 = $[35];
  }
  let t18;
  if ($[36] !== t16 || $[37] !== t17) {
    t18 = <div className="tw-mt-0.5 tw-flex tw-min-w-0 tw-items-center tw-gap-1.5 tw-text-[11px]">{t16}{t17}</div>;
    $[36] = t16;
    $[37] = t17;
    $[38] = t18;
  } else {
    t18 = $[38];
  }
  let t19;
  if ($[39] !== t15 || $[40] !== t18) {
    t19 = <div className="tw-flex tw-min-w-0 tw-flex-col tw-justify-center">{t15}{t18}</div>;
    $[39] = t15;
    $[40] = t18;
    $[41] = t19;
  } else {
    t19 = $[41];
  }
  let t20;
  if ($[42] !== t13 || $[43] !== t19) {
    t20 = <div className="tw-flex tw-min-w-0 tw-flex-1 tw-items-center tw-gap-3">{t13}{t19}</div>;
    $[42] = t13;
    $[43] = t19;
    $[44] = t20;
  } else {
    t20 = $[44];
  }
  let t21;
  if ($[45] !== selectionIndicator) {
    t21 = <div className="tw-flex tw-flex-shrink-0 tw-items-center tw-justify-end tw-pl-2">{selectionIndicator}</div>;
    $[45] = selectionIndicator;
    $[46] = t21;
  } else {
    t21 = $[46];
  }
  let t22;
  if ($[47] !== isSelected || $[48] !== t20 || $[49] !== t21 || $[50] !== t6 || $[51] !== t7 || $[52] !== t8 || $[53] !== t9) {
    t22 = <div className="tw-relative tw-col-span-1"><div role="button" tabIndex={0} aria-pressed={isSelected} aria-label={t6} onClick={t7} onKeyDown={t8} className={t9}>{t20}{t21}</div></div>;
    $[47] = isSelected;
    $[48] = t20;
    $[49] = t21;
    $[50] = t6;
    $[51] = t7;
    $[52] = t8;
    $[53] = t9;
    $[54] = t22;
  } else {
    t22 = $[54];
  }
  return t22;
}
function _temp(event_1) {
  event_1.stopPropagation();
}